const getConst = (
    name:
        | "auth-token-name"
        | "db-name"
        | "game-id"
        | "api-url"
        | "front-url"
        | "menu-width"
        | "app-version"
        | "files-url"
        | "game-files-url"
        | "app-title"
        | "qr-prefix"
        | "lang"
        | "base-url"
        | "assets-images-path"
        | "server-base-url"
        | "server-main-url"
        | "yandex-target"
): any => {
    switch (name) {
        case "db-name":
            if (process.env.REACT_APP_GAME_ID === "30") {
                return process.env.REACT_APP_COOKIE_NAME;
            }
            return process.env.REACT_APP_COOKIE_NAME + "-" + process.env.REACT_APP_GAME_ID;
        case "auth-token-name":
            return process.env.REACT_APP_COOKIE_NAME;
        case "menu-width":
            return 280;
        case "game-id":
            return process.env.REACT_APP_GAME_ID;
        case "api-url":
            return process.env.REACT_APP_API_URL;
        case "front-url":
            return process.env.PUBLIC_URL;
        case "files-url":
            return process.env.REACT_APP_FILES_URL;
        case "game-files-url":
            return process.env.REACT_APP_GAME_FILES_URL;
        case "app-version":
            return process.env.REACT_APP_VERSION;
        case "app-title":
            return process.env.REACT_APP_WEBSITE_NAME;
        case "qr-prefix":
            return process.env.REACT_APP_QR_PREFIX;
        case "lang":
            return process.env.REACT_APP_LANG;
        case "base-url":
            return process.env.REACT_APP_BASE_URL;
        case "server-base-url":
            return process.env.REACT_APP_BASE_URL;
        case "yandex-target":
            return process.env.REACT_APP_YANDEX_TARGET || "";
        case "server-main-url":
            return process.env.REACT_APP_BASE_URL + "main/#/";
        case "assets-images-path":
            return "./assets/images/";
    }
};
export default getConst;
